import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import classNames from 'classnames'
import { QuickLinkType } from 'types'
import { useReferralEnabled } from 'utils'

const propTypes = {
  links: PropTypes.arrayOf(QuickLinkType).isRequired,
  header: PropTypes.string,
}

function QuickLinks({ links, header = 'Quick Links' }) {
  const isReferralEnabled = useReferralEnabled()

  return (
    <section
      className={classNames('card quick-links', {
        'referral-enabled': isReferralEnabled,
      })}
    >
      <h3>{header}</h3>

      <ul>
        {links.map(({ linkName, path }) => (
          <li key={linkName}>
            <a href={path}>{linkName}</a>
          </li>
        ))}
      </ul>
    </section>
  )
}

QuickLinks.propTypes = exact(propTypes)

export default pure(QuickLinks)
